import { deleteSavedFilter, saveNewFilter } from 'modules/contacts/api/contact-api'
import { ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum'
import {
  ContactFieldApiInterface,
  ContactFilterSavedApiInterface,
  ContactFilterSavedInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'
import { getConditions } from 'modules/contacts/utils/get-conditions'
import { setFilterFieldValue } from 'modules/contacts/utils/set-contact-filter'
import { KeyedMutator } from 'swr'

export const useContactFilterActions = ({
  filter,
  setFilter,
  mutateSavedFields,
  filterFields,
  clearFilter,
}: {
  filter: ContactFilterType
  setFilter: React.Dispatch<React.SetStateAction<ContactFilterType>>
  mutateSavedFields: KeyedMutator<ContactFilterSavedApiInterface>
  filterFields: ContactFieldApiInterface | undefined
  clearFilter: () => void
}) => {
  const onDeleteSavedFilter = async (filter: ContactFilterSavedInterface) => {
    try {
      await deleteSavedFilter(filter.id)
      await mutateSavedFields(data => {
        if (data) {
          const deletedElIdx = data.items.findIndex(el => el.id === filter.id)
          data.items.splice(deletedElIdx, 1)
          return { ...data }
        }
      })
    } catch (e) {
      throw e
    }
  }

  const applySavedFilters = (savedFilter: ContactFilterSavedInterface) => {
    if (filterFields) {
      clearFilter()
      const newFilter = savedFilter.values.reduce((obj, el) => {
        const filterFieldItem = filterFields.items.find(e => e.id.toString() === el.searchField)
        if (filterFieldItem) {
          return { ...setFilterFieldValue({ filter: obj, value: el, slug: filterFieldItem.slug }) }
        } else {
          return {
            ...setFilterFieldValue({
              filter: obj,
              value: el,
              slug: ContactSearchFieldEnum[el.searchField as keyof typeof ContactSearchFieldEnum],
            }),
          }
        }
      }, {} as ContactFilterType)
      setFilter(prev => ({ ...prev, ...newFilter }))
    }
  }

  const onSaveNewFilter = async (data: { name: string }) => {
    try {
      const savedData: Omit<ContactFilterSavedInterface, 'id'> = {
        name: data.name,
        values: getConditions({ filter, filterFields }),
      }
      const response = await saveNewFilter(savedData)
      await mutateSavedFields(data => {
        if (data) {
          return { ...data, items: [...data.items, response.data] }
        }
      }, false)
    } catch (e) {
      throw e
    }
  }

  return {
    applySavedFilters,
    onDeleteSavedFilter,
    onSaveNewFilter,
  }
}
